import { Box } from '@material-ui/core';

import { HtmlEditor } from '@components';

import { useStyles } from './EditTab.styles';
import { useState } from 'react';

/**
 EditTab route component
 @returns {JSX.Element}
 */

type TProps = {
  moduleHtml: string;
  headerHeight?: number;
  onEditorChange?: (value: string) => void;
};
export const EditTab: React.FC<TProps> = ({ moduleHtml, headerHeight, onEditorChange }): JSX.Element => {
  const styles = useStyles();
  const [code, setCode] = useState<string>(moduleHtml);

  const handleCodeChanged = (value: string) => {
    setCode(value);

    if (onEditorChange) {
      onEditorChange(value);
    }
  };

  return (
    <Box className={styles.editTab}>
      <HtmlEditor
        // style={{ maxHeight: `calc(100vh - ${headerHeight ?? 0}px - 150px)` }}
        style={{ maxHeight: 'unset' }}
        value={code}
        onUpdate={handleCodeChanged}
      />
    </Box>
  );
};
